export function initVideos({ motion, scope }) {
  const document=scope.document;
  const window=scope.ownerDocument.defaultView;
  const matchMedia=window.matchMedia.bind(window);
  const videos = [...document.querySelectorAll("[data-background-video]")];
  const visible = new Set();
  const update = () =>
    videos.forEach((video) => {
      if (motion.enabled && visible.has(video) && !document.hidden)
        video.play().catch(() => {});
      else video.pause();
    });
  const observer = new scope.IntersectionObserver(
    (entries) => {
      entries.forEach((e) =>
        e.isIntersecting ? visible.add(e.target) : visible.delete(e.target),
      );
      update();
    },
    { threshold: 0.05 },
  );
  videos.forEach((video) => observer.observe(video));
  scope.on(document, "aw:motionchange", update);
  scope.on(document, "visibilitychange", update);
  scope.onDispose(()=>videos.forEach(video=>video.pause()));
}
